// endpoint documentation: https://developer.syf.com/api-reference/account-activity-v1#operation/getSpendCategories
export var trendsUrl = 'v1/credit/accounts/activity/spend-categories';
//# sourceMappingURL=spending-trends-api.js.map